// Add BASE_URL definition
const BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;

export async function getPromptConfig() {
    const res = await fetch(`${BASE_URL}/config/prompt`);
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function setPromptConfig(data) {
    const res = await fetch(`${BASE_URL}/config/prompt`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function getDefaultKimiPrompt() {
    const res = await fetch(`${BASE_URL}/config/kimi-default-prompt`);
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function getAIProvider() {
    const res = await fetch(`${BASE_URL}/config/ai-provider`);
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function setAIProvider(data) {
    const res = await fetch(`${BASE_URL}/config/ai-provider`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

// Comprehensive settings endpoints
export async function getSettings() {
    const res = await fetch(`${BASE_URL}/config/settings`);
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function updateSettings(data) {
    const res = await fetch(`${BASE_URL}/config/settings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

// Add real scrape API helpers
export async function scrapeWebsite(data) {
    const res = await fetch(`${BASE_URL}/scrape/website`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function scrapeGmaps(data) {
    const res = await fetch(`${BASE_URL}/scrape/gmaps`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function scrapeLRK(data) {
    const res = await fetch(`${BASE_URL}/scrape/lrk`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function getResultsList() {
    const res = await fetch(`${BASE_URL}/results`);
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function getResult(facilityId, type) {
    const res = await fetch(`${BASE_URL}/results/${facilityId}/${type}`);
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

// Kimi Analysis API
export async function analyzeWithKimi(data) {
    const res = await fetch(`${BASE_URL}/analyze/kimi`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

// Kimi Facility Analysis API (saves to database)
export async function analyzeFacilityWithKimi(facilityId, data = {}) {
    // Create AbortController for timeout control (10 minutes)
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 600000); // 10 minutes

    try {
        const res = await fetch(`${BASE_URL}/api/facilities/${facilityId}/analyze/kimi`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
            signal: controller.signal
        });

        clearTimeout(timeoutId);

        if (!res.ok) throw new Error(await res.text());
        return res.json();
    } catch (error) {
        clearTimeout(timeoutId);
        if (error.name === 'AbortError') {
            throw new Error('Kimi analysis timed out after 10 minutes');
        }
        throw error;
    }
}

// Kimi Batch Analysis API
export async function batchAnalyzeWithKimi(facilityIds) {
    const res = await fetch(`${BASE_URL}/api/analysis/kimi/batch`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ facility_ids: facilityIds }),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
} 